module.exports = __webpack_public_path__ + "img/shenzhen.20c5f6b5.jpg";